import * as l from "react";
const h = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "UZ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#UZ_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16h32v8H0v-8z",
      fill: "#14DC5A"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v10H0V0z",
      fill: "#0099B5"
    }
  ), /* @__PURE__ */ l.createElement("path", { d: "M-2 9.5h-.5v7h37v-7H-2z", fill: "#F7FCFF", stroke: "#C51918" }), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.541 3.007l-.673.374.193-.76-.645-.559h.842l.283-.72.33.72h.719l-.565.559.272.76-.756-.374zm-3.608 2.29l.673-.373.755.373-.27-.76.563-.558h-.718l-.33-.72-.283.72h-.842l.644.558-.192.76zM8.428 6.962l-.673.374.192-.76-.644-.559h.842l.282-.72.331.72h.718l-.564.559.271.76-.755-.374zm3.178 0l-.673.374.192-.76-.645-.559h.843l.282-.72.331.72h.718l-.564.559.271.76-.755-.374zm2.98 0l-.673.374.193-.76-.645-.559h.842l.282-.72.332.72h.717l-.564.559.272.76-.756-.374zm-.673-1.664l.673-.374.756.374-.272-.76.564-.559h-.717l-.332-.72-.282.72h-.842l.645.559-.193.76zm2.998 2.038l.673-.374.756.374-.271-.76.564-.559h-.718l-.331-.72-.283.72h-.842l.645.559-.192.76zm.673-2.412l-.672.374.192-.76-.645-.559h.842l.283-.72.33.72h.718l-.564.559.272.76-.756-.374zM16.87 3.38l.672-.374.756.374-.271-.76.564-.559h-.718l-.331-.72-.283.72h-.842l.645.559-.192.76zm3.747 3.58l-.673.375.192-.76-.645-.559h.842l.283-.72.33.72h.719l-.564.559.27.76-.754-.374zm-.673-1.664l.673-.373.755.373-.271-.76.564-.558h-.718l-.331-.72-.283.72h-.842l.645.558-.192.76zm.628-2.29l-.673.374.192-.76-.645-.559h.842l.283-.72.331.72h.718l-.564.559.271.76-.755-.374zM5.885 8.24s-2.416-.656-2.37-3.08C3.56 2.739 6 2.11 6 2.11c-.997-.377-3.945.13-4 3.028-.054 2.9 2.956 3.47 3.885 3.104z",
      fill: "#F7FCFF"
    }
  ))
), t = h;
export {
  t as default
};
